module.exports = __webpack_public_path__ + "img/零售-标签打印机.68016845.jpg";